function readAloudFormErrors(selector) {
  const errorElements = document.querySelectorAll(selector);
  for (const errorElement of errorElements) {
    const prev = errorElement?.previousElementSibling;
    if (!prev) continue;

    let input = prev.querySelector?.('input, select, textarea');
    if (!input && prev.tagName?.toLowerCase() === 'fieldset') {
      input =
        prev.querySelector('input[type="radio"]:checked') ||
        prev.querySelector('input[type="radio"]');
    }
    if (input) {
      input.focus();
      // input.setAttribute('aria-invalid', 'true');
      errorElement.setAttribute('aria-live', 'assertive');
      return;
    }
  }
}

export default readAloudFormErrors;
